// Shared accepted-file-types config for every document-upload surface (s105 DB-1).
//
// Keep `DOCUMENT_ACCEPT` (the <input accept> value) and `DOCUMENT_ACCEPT_LABEL` (the
// planner-facing copy) in sync. The server stores the original as-is and converts
// Word(.docx)/Excel → text/CSV before extraction (server/document-convert.ts). s142: legacy
// binary `.doc` is ACCEPTED (attaches) but does NOT extract — mammoth is .docx-only — so the
// planner label names Word as ".docx" to set the honest extraction expectation.

/** `<input accept>` value: PDF, images, Word, Excel, CSV, text. (.doc attaches but won't extract.) */
export const DOCUMENT_ACCEPT = ".pdf,image/*,.doc,.docx,.xls,.xlsx,.csv,.txt";

/** Planner-facing description of the accepted set — no MIME types, no jargon. */
export const DOCUMENT_ACCEPT_LABEL = "Supports PDF, Word (.docx), Excel, CSV, images, and text files";

/** Same accepted set, framed for the Build-from-Documents card (which already carries a
 *  content-type "Supports…" line, so this one leads with "Upload as…" to avoid two stacked
 *  "Supports…" lines). Keep the format list in sync with DOCUMENT_ACCEPT / _LABEL above. */
export const DOCUMENT_ACCEPT_CARD_LINE = "Upload as PDF, Word (.docx), Excel, CSV, image, or text files.";
